export const getLocalStorageItem = (key) => {
    try {
        return localStorage.getItem(key);
    }
    catch (e) {
        return null;
    }
};
export const setLocalStorageItem = (key, val) => {
    try {
        return localStorage.setItem(key, val);
    }
    catch (e) {
        return null;
    }
};
/**
 * Identify if this browser is sus(picious). This can be used to determine if we
 * need to avoid reporting data or providing features to this user
 *
 * Known sus browsers:
 *  - Chrome 71 - heavily used by spammers on our /drop pages
 */
export const isBrowserSus = (() => {
    const rawChromiumGroup = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    const chromiumVersion = rawChromiumGroup && parseInt(rawChromiumGroup[2], 10);
    // arbitrary older chrome version. bots and spammers generally using outdated
    // versions of browsers.
    return rawChromiumGroup && chromiumVersion ? chromiumVersion <= 91 : false;
})();
/**
 * @returns the number of page loads this device has performed
 */
export function getDeviceLoadCount() {
    const loadCountKey = 'ntl_device_loads';
    const currentCount = parseInt(getLocalStorageItem(loadCountKey) || '0', 10) || 0;
    const newCount = currentCount + 1;
    Promise.resolve().then(() => {
        setLocalStorageItem(loadCountKey, newCount);
    });
    return newCount;
}
//# sourceMappingURL=utils.js.map